import React from 'react';
import { Card, CardContent, Typography, Stack, Box, SxProps, Theme } from '@mui/material';

type Props = {
  title?: string;
  subtitle?: string;
  action?: Element | any;
  footer?: React.JSX.Element;
  cardheading?: string | React.JSX.Element;
  headtitle?: string | React.JSX.Element;
  headsubtitle?: string | React.JSX.Element;
  children?: React.JSX.Element;
  middlecontent?: string | React.JSX.Element;
  sx?: SxProps<Theme>;
};

const DashboardCard = ({
  title,
  subtitle,
  children,
  action,
  footer,
  cardheading,
  headtitle,
  headsubtitle,
  middlecontent,
  sx,
}: Props) => {
  return (
    <Card
      sx={{
        width: '100%',
        maxWidth: { xs: '100%', md: 800 },
        mx: 'auto',
        boxShadow: 3,
        p: 0,
        ...sx,
      }}
      elevation={9}
      variant={undefined}
    >
      {cardheading ? (
        <CardContent sx={{ p: { xs: 1, sm: 3 } }}>
          <Typography variant="h4">{headtitle}</Typography>
          <Typography variant="subtitle2" color="textSecondary">
            {headsubtitle}
          </Typography>
        </CardContent>
      ) : (
        <CardContent sx={{ p: { xs: 1, sm: 3 }, fontSize: { xs: 14, sm: 15, md: 16 } }}>
          {title ? (
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems={'center'}
              mb={3}
            >
              <Box>
                {title ? <Typography variant="h4">{title}</Typography> : ''}

                {subtitle ? (
                  <Typography variant="subtitle2" color="textSecondary">
                    {subtitle}
                  </Typography>
                ) : (
                  ''
                )}
              </Box>
              {action}
            </Stack>
          ) : null}

          {children}
        </CardContent>
      )}

      {middlecontent}
      {footer}
    </Card>
  );
};

export default DashboardCard;
